<div class="faq-wrapper">
    <iframe #videoTutorial id="video-tutorial-frame" frameborder="0" allowfullscreen></iframe>
</div>
